import React from 'react';
import dynamic from 'next/dynamic';

import { ProductPageTemplate } from 'src/templates';
import { ProductPageHeader } from 'src/components/headers/ProductPageHeader';
import Features from 'src/components/features';
import FeatureSectionUsecases from 'src/components/features/feature-section-usecases';
import Quote from 'src/components/quote';
import FooterExtension from 'src/components/footer-extension';

import { Locales } from 'src/lib/constants';

// data
import {
  metaData,
  productHeaderData,
  investmentsHoldingsExampleData,
  investmentsTrxnsExampleData,
  featuredUsesCasesData,
  featuresData,
  quoteData,
  footerExtensionData,
} from 'src/store/en-gb/products/investments';

const StaticData = dynamic(
  () => {
    return import('src/components/Surfaces/StaticData/StaticData.jsx');
  },
  {
    ssr: false,
  },
);

const UKProductInvestments = ({ locale = Locales.EN_GB }) => {
  return (
    <ProductPageTemplate
      fields={{ components: [], ...metaData }}
      locale={locale}
    >
      <ProductPageHeader {...productHeaderData} />
      <Features {...featuresData} />
      <StaticData {...investmentsHoldingsExampleData} />
      <StaticData {...investmentsTrxnsExampleData} />
      <FeatureSectionUsecases {...featuredUsesCasesData} />
      <Quote {...quoteData} />
      <FooterExtension {...footerExtensionData} />
    </ProductPageTemplate>
  );
};

export default UKProductInvestments;
